export function murmurHashOfSize(size: number, h: number): number {
    h = Math.imul(h, 0xcc9e2d51);
    h = Math.imul((h << 15) | (h >>> -15), 0x1b873593);
    h = Math.imul((h << 13) | (h >>> -13), 5);
    h = ((h + 0xe6546b64) | 0) ^ size;
    h = Math.imul(h ^ (h >>> 16), 0x85ebca6b);
    h = Math.imul(h ^ (h >>> 13), 0xc2b2ae35);
    h = smi(h ^ (h >>> 16));
    return h;
}

export function hashMerge(a: number, b: number): number {
    return (a ^ (b + 0x9e3779b9 + (a << 6) + (a >> 2))) | 0; // int
}

/**
 * v8 has an optimization for storing 31-bit signed numbers.
 * Values which have either 00 or 11 as the high order bits qualify.
 * This function drops the highest order bit in a signed number, maintaining
 * the sign bit.
 */
export function smi(i32: number): number {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xbfffffff);
}
